import AddTablePreSedationTH from "./AddTablePreSedationTH";

export default function toPDFMakeData(props: any) {
  return {
    pageSize: `A4`,
    defaultStyle: {
      font: `THSarabunNew`,
    },
    pageOrientation: `portrait`,
    content: [
      {
        bold: `true`,
        fontSize: `18`,
        text: `หนังสือยินยอมก่อนการให้ยาระงับปวดหรือยาระงับความรู้สึกตัวการทำหัตถการ/การผ่าตัด`,
        pageBreak: ``,
        decorationColor: ``,
        width: `auto`,
        decorationStyle: ``,
        alignment: `center`,
        color: ``,
        preserveLeadingSpaces: true,
        decoration: ``,
      },
      {
        alignment: `left`,
        fontSize: 15,
        decoration: ``,
        color: ``,
        bold: false,
        decorationColor: ``,
        decorationStyle: ``,
        pageBreak: ``,
        text: ` `,
        width: `auto`,
        preserveLeadingSpaces: true,
      },
      {
        columns: [
          {
            preserveLeadingSpaces: true,
            fontSize: 15,
            bold: false,
            width: 30,
            decoration: ``,
            alignment: `left`,
            decorationColor: ``,
            text: ``,
            decorationStyle: ``,
            pageBreak: ``,
            color: ``,
          },
          {
            alignment: `left`,
            fontSize: 15,
            pageBreak: ``,
            decorationColor: ``,
            text: `ข้าพเจ้าขอแสดงความยินยอมโดยความสมัครใจ ให้มีการเฝ้าติดตามการทำงานของร่างกายและให้มีการใช้ยากล่อมประสาท`,
            preserveLeadingSpaces: true,
            decoration: ``,
            color: ``,
            bold: false,
            width: `auto`,
            decorationStyle: ``,
          },
        ],
      },
      {
        columns: [
          {
            color: ``,
            pageBreak: ``,
            decoration: ``,
            width: `auto`,
            preserveLeadingSpaces: true,
            text: `และยาระงับความรู้สึกภายใต้การดูแลของนายแพทย์/แพทย์หญิง`,
            alignment: `left`,
            fontSize: 15,
            decorationStyle: ``,
            bold: false,
            decorationColor: ``,
          },
          {
            bold: false,
            width: 5,
            fontSize: 15,
            color: ``,
            margin: [0, 0, 0, 0],
            preserveLeadingSpaces: true,
            decorationColor: ``,
            text: ` `,
            decoration: ``,
            pageBreak: ``,
            decorationStyle: ``,
            alignment: `left`,
          },
          {
            stack: [
              {
                preserveLeadingSpaces: true,
                color: ``,
                decorationColor: ``,
                fontSize: 15,
                alignment: `center`,
                text: props.items?.formatDoctor,
                margin: [0, 0, 0, -15],
                width: `auto`,
                decorationStyle: ``,
                bold: false,
                decoration: ``,
                pageBreak: ``,
              },
              {
                color: ``,
                decorationStyle: ``,
                margin: [0, 0, 0, 0],
                fontSize: 15,
                alignment: `left`,
                decorationColor: ``,
                width: `auto`,
                pageBreak: ``,
                preserveLeadingSpaces: true,
                bold: false,
                decoration: ``,
                text: `.............................................................`,
              },
            ],
          },
          {
            decorationStyle: ``,
            decoration: ``,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            bold: false,
            decorationColor: ``,
            width: `auto`,
            color: ``,
            text: `หรือแพทย์ที่ได้รับมอบหมาย`,
            fontSize: 15,
            alignment: `left`,
          },
        ],
      },
      {
        decoration: ``,
        decorationStyle: ``,
        color: ``,
        text: `ให้ทำหน้าที่ ของโรงพยาบาลเซเปี้ยนซ์`,
        width: `auto`,
        decorationColor: ``,
        alignment: `left`,
        pageBreak: ``,
        bold: false,
        preserveLeadingSpaces: true,
        fontSize: 15,
      },
      {
        columns: [
          {
            text: ``,
            bold: false,
            fontSize: 15,
            decoration: ``,
            color: ``,
            alignment: `left`,
            preserveLeadingSpaces: true,
            width: 30,
            pageBreak: ``,
            decorationStyle: ``,
            decorationColor: ``,
          },
          {
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            bold: false,
            decoration: ``,
            pageBreak: ``,
            alignment: `left`,
            color: ``,
            decorationColor: ``,
            fontSize: 15,
            text: `ข้าพเจ้า `,
            width: `auto`,
          },
          {
            color: ``,
            decorationColor: ``,
            bold: false,
            text: ` `,
            margin: [0, 0, 0, 0],
            decorationStyle: ``,
            alignment: `left`,
            pageBreak: ``,
            width: 5,
            preserveLeadingSpaces: true,
            decoration: ``,
            fontSize: 15,
          },
          {
            stack: [
              {
                alignment: `left`,
                width: `auto`,
                decorationColor: ``,
                decorationStyle: ``,
                pageBreak: ``,
                color: ``,
                margin: [0, 0, 0, -15],
                decoration: ``,
                fontSize: 15,
                text: props.items?.formatPatient,
                bold: false,
                preserveLeadingSpaces: true,
              },
              {
                margin: [0, 0, 0, 0],
                alignment: `left`,
                bold: false,
                width: `auto`,
                color: ``,
                fontSize: 15,
                decoration: ``,
                decorationStyle: ``,
                text: `........................................................................................................................................................................................`,
                preserveLeadingSpaces: true,
                pageBreak: ``,
                decorationColor: ``,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            bold: false,
            text: `ได้รับการนัดหมายเพื่อทำหัตถการ/การผ่าตัด`,
            pageBreak: ``,
            decoration: ``,
            margin: [0, 0, 0, 0],
            fontSize: 15,
            preserveLeadingSpaces: true,
            alignment: `left`,
            color: ``,
            decorationStyle: ``,
            width: 175,
            decorationColor: ``,
          },
          {
            decorationColor: ``,
            fontSize: 15,
            decoration: ``,
            preserveLeadingSpaces: true,
            color: ``,
            decorationStyle: ``,
            text: ` `,
            pageBreak: ``,
            alignment: `left`,
            bold: false,
            margin: [0, 0, 0, 0],
            width: 5,
          },
          {
            stack: [
              {
                bold: false,
                text: props.items?.formatOperation,
                width: `auto`,
                decoration: ``,
                alignment: `left`,
                decorationStyle: ``,
                preserveLeadingSpaces: true,
                color: ``,
                margin: [0, 0, 0, -15],
                fontSize: 15,
                pageBreak: ``,
                decorationColor: ``,
              },
              {
                bold: false,
                preserveLeadingSpaces: true,
                color: ``,
                width: `auto`,
                decorationStyle: ``,
                decorationColor: ``,
                margin: [0, 0, 0, 0],
                pageBreak: ``,
                text: `.........................................................................................................................................`,
                decoration: ``,
                alignment: `left`,
                fontSize: 15,
              },
            ],
          },
        ],
      },
      {
        color: ``,
        decorationStyle: ``,
        alignment: `left`,
        text: `ข้าพเจ้าได้รับการอธิบายและยอมรับว่าการใช้ยาระงับความรู้สึก ไม่ว่าจะในรูปแบบใดก็ตาม อาจก่อให้เกิดภาวะแทรกซ้อนต่างๆ แม้อุบัติการณ์ของภาวะแทรกซ้อนที่ร้ายแรงจะต่ำ แต่ก็เกิดได้โดยไม่คาดหมาย เช่น การติดเชื้อ มีเลือดออกผิดปกติ ฟันได้รับ`,
        decoration: ``,
        pageBreak: ``,
        width: `auto`,
        decorationColor: ``,
        preserveLeadingSpaces: true,
        bold: false,
        fontSize: 15,
      },
      {
        text: `ความเสียหาย ปฏิกิริยาอันไม่พึงประสงค์ต่อยาที่ได้รับ ลิ่มเลือกอุดตันในหลอดเลือด สูญเสียความรู้สึก สูญเสียการมองเห็น สูญเสียการทำงานของแขนและขา อัมพาต สมองและหัวใจทำงานผิดปกติ อวัยวะเสียหน้าที่หรือหยุดการทำงาน หรือเสียชีวิต ภาวะแทรกซ้อน ตามที่ระบุข้างท้ายนี้ สามารถเกิดขึ้นได้กับข้าพเจ้าเช่นกัน ข้าพเจ้าเข้าใจความเสี่ยง ประโยชน์ ทางเลือกวิธีการ`,
        pageBreak: ``,
        width: `auto`,
        alignment: `left`,
        bold: false,
        decorationStyle: ``,
        preserveLeadingSpaces: true,
        color: ``,
        decoration: ``,
        fontSize: 15,
        decorationColor: ``,
      },
      {
        preserveLeadingSpaces: true,
        decorationColor: ``,
        text: `ใช้ยาระงับความรู้สึก และยาระงับปวดหลังทำหัตถการ ตามรูปแบบที่เลือกด้านล่าง แต่ในบางกรณีการใช้ยาระงับความรู้สึก บาง`,
        decoration: ``,
        pageBreak: ``,
        decorationStyle: ``,
        alignment: `left`,
        fontSize: 15,
        width: `auto`,
        color: ``,
        bold: false,
      },
      {
        decorationColor: ``,
        bold: false,
        alignment: `left`,
        preserveLeadingSpaces: true,
        decoration: ``,
        text: `ประเภท เช่น ยาชาเฉพาะที่อาจจะไม่ประสบความสำเร็จและจำเป็นต้องปรับเปลี่ยนใช้วิธีอื่นๆ ร่วมด้วยหรือใช้แทน เช่น ดมยาสลบ เป็นต้น`,
        color: ``,
        pageBreak: ``,
        width: `auto`,
        decorationStyle: ``,
        fontSize: 15,
      },
      {
        columns: [
          {
            color: ``,
            alignment: `left`,
            decoration: ``,
            bold: false,
            preserveLeadingSpaces: true,
            text: ``,
            pageBreak: ``,
            decorationStyle: ``,
            width: 30,
            decorationColor: ``,
            fontSize: 15,
          },
          {
            bold: false,
            pageBreak: ``,
            width: `auto`,
            alignment: `left`,
            fontSize: 15,
            decorationColor: ``,
            text: `ข้าพเจ้ายินยอมรับยาระงับความรู้สึกตามที่ระบุด้านล่าง ร่วมทั้งการปรับเปลี่ยนเพื่อใช้วิธีอื่นๆ หากมีความจำเป็น`,
            decoration: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            color: ``,
          },
        ],
      },
      {
        width: `auto`,
        decoration: ``,
        bold: false,
        alignment: `left`,
        color: ``,
        fontSize: 15,
        decorationStyle: ``,
        preserveLeadingSpaces: true,
        pageBreak: ``,
        text: `รูปแบบการใช้ยาระงับความรู้สึก`,
        decorationColor: ``,
      },
      {
        columns: [
          {
            alignment: `left`,
            fontSize: 15,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            color: ``,
            width: 30,
            decoration: ``,
            bold: false,
            text: ``,
            decorationStyle: ``,
          },
          {
            preserveLeadingSpaces: true,
            alignment: `center`,
            text: `[  ]`,
            pageBreak: ``,
            width: `auto`,
            color: ``,
            fontSize: 15,
            bold: false,
            decorationColor: ``,
            decoration: ``,
            decorationStyle: ``,
          },
          {
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            decoration: ``,
            decorationColor: ``,
            pageBreak: ``,
            text: ``,
            alignment: `left`,
            bold: false,
            color: ``,
            fontSize: 15,
            width: 5,
          },
          {
            text: `ดมยาสลบ หรือบริหารยาสลบทางหลอดเลือดดำ `,
            alignment: `left`,
            bold: false,
            decoration: ``,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            fontSize: 15,
            color: ``,
            pageBreak: ``,
            width: `auto`,
          },
        ],
      },
      {
        columns: [
          {
            decorationColor: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            fontSize: 15,
            decoration: ``,
            text: ``,
            width: 30,
            alignment: `left`,
            color: ``,
            pageBreak: ``,
            bold: false,
          },
          {
            alignment: `center`,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            pageBreak: ``,
            width: `auto`,
            color: ``,
            fontSize: 15,
            text: `[  ]`,
            decorationColor: ``,
            bold: false,
            decoration: ``,
          },
          {
            width: 5,
            preserveLeadingSpaces: true,
            decoration: ``,
            text: ``,
            color: ``,
            bold: false,
            decorationColor: ``,
            alignment: `left`,
            pageBreak: ``,
            fontSize: 15,
            decorationStyle: ``,
          },
          {
            color: ``,
            alignment: `left`,
            width: `auto`,
            pageBreak: ``,
            decorationColor: ``,
            decorationStyle: ``,
            fontSize: 15,
            decoration: ``,
            text: `การเฝ้าติดตามการทำงานของร่างกายอย่างใกล้ชิด (ใช้หรือไม่ใช้ยากล่อมประสาทร่วมด้วย)`,
            bold: false,
            preserveLeadingSpaces: true,
          },
        ],
      },
      {
        columns: [
          {
            decorationStyle: ``,
            decorationColor: ``,
            text: ``,
            width: 30,
            color: ``,
            decoration: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            bold: false,
            alignment: `left`,
            pageBreak: ``,
          },
          {
            decorationStyle: ``,
            width: `auto`,
            decorationColor: ``,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            bold: false,
            decoration: ``,
            alignment: `center`,
            fontSize: 15,
            color: ``,
            text: `[  ]`,
          },
          {
            pageBreak: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            decoration: ``,
            color: ``,
            decorationColor: ``,
            text: ``,
            width: 5,
            alignment: `left`,
            fontSize: 15,
            bold: false,
          },
          {
            width: `auto`,
            preserveLeadingSpaces: true,
            fontSize: 15,
            decoration: ``,
            decorationStyle: ``,
            bold: false,
            text: `บล็อกหลัง (ใช้หรือไม่ใช้ยากล่อมประสาทร่วมด้วย)`,
            alignment: `left`,
            decorationColor: ``,
            color: ``,
            pageBreak: ``,
          },
        ],
      },
      {
        columns: [
          {
            width: 30,
            alignment: `left`,
            color: ``,
            text: ``,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            fontSize: 15,
            bold: false,
            decorationStyle: ``,
            decoration: ``,
            pageBreak: ``,
          },
          {
            fontSize: 15,
            preserveLeadingSpaces: true,
            bold: false,
            pageBreak: ``,
            width: `auto`,
            color: ``,
            decorationColor: ``,
            decorationStyle: ``,
            text: `[  ]`,
            alignment: `center`,
            decoration: ``,
          },
          {
            width: 5,
            decoration: ``,
            preserveLeadingSpaces: true,
            text: ``,
            pageBreak: ``,
            alignment: `left`,
            decorationColor: ``,
            color: ``,
            bold: false,
            decorationStyle: ``,
            fontSize: 15,
          },
          {
            bold: false,
            text: `บล็อกเส้นประสาท (ใช้หรือไม่ใช้ยากล่อมประสาทร่วมด้วย)`,
            decorationStyle: ``,
            pageBreak: ``,
            decorationColor: ``,
            width: `auto`,
            preserveLeadingSpaces: true,
            alignment: `left`,
            decoration: ``,
            color: ``,
            fontSize: 15,
          },
        ],
      },
      {
        columns: [
          {
            decorationStyle: ``,
            width: 30,
            decoration: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            text: ``,
            color: ``,
            alignment: `left`,
            pageBreak: ``,
            bold: false,
            decorationColor: ``,
          },
          {
            alignment: `center`,
            preserveLeadingSpaces: true,
            color: ``,
            decorationColor: ``,
            text: `[  ]`,
            fontSize: 15,
            bold: false,
            pageBreak: ``,
            width: `auto`,
            decoration: ``,
            decorationStyle: ``,
          },
          {
            bold: false,
            fontSize: 15,
            alignment: `left`,
            text: ``,
            decorationStyle: ``,
            decoration: ``,
            width: 5,
            preserveLeadingSpaces: true,
            color: ``,
            decorationColor: ``,
            pageBreak: ``,
          },
          {
            decorationColor: ``,
            color: ``,
            alignment: `left`,
            pageBreak: ``,
            bold: false,
            fontSize: 15,
            decoration: ``,
            decorationStyle: ``,
            text: `ยากล่อมประสาท`,
            width: `auto`,
            preserveLeadingSpaces: true,
          },
        ],
      },
      {
        columns: [
          {
            alignment: `left`,
            decoration: ``,
            preserveLeadingSpaces: true,
            bold: false,
            color: ``,
            decorationStyle: ``,
            pageBreak: ``,
            width: 30,
            fontSize: 15,
            decorationColor: ``,
            text: ``,
          },
          {
            bold: false,
            decoration: ``,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            alignment: `left`,
            pageBreak: ``,
            color: ``,
            fontSize: 15,
            width: `auto`,
            decorationStyle: ``,
            text: `ข้าพเจ้าเข้าใจว่า กรณีที่ข้าพเจ้าเสพหรือใช้สารเสพติดชนิดใดๆ ก็ตามอันอาจมีผลทำให้เกิดภาวะแทรกซ้อนเพิ่มขึ้นได้ `,
          },
        ],
      },
      {
        text: `จำเป็นจะต้องแจ้งให้วิสัญญีแพทย์ทราบ ในกรณีที่ข้าพเจ้าได้รับอนุญาตให้กลับบ้านได้ภายใน 24 ชั่วโมง หลังจากการผ่าตัดนั้น ข้าพเจ้าจะไม่ขับขี่ยานพาหนะหรือใช้ยานพาหนะโดยสารสาธารณะใดๆ และจะมีบุคคลบรรลุนิติภาวะนำ (หรือพา) ข้าพเจ้ากลับที่พัก`,
        width: `auto`,
        bold: false,
        preserveLeadingSpaces: true,
        decoration: ``,
        decorationStyle: ``,
        decorationColor: ``,
        alignment: `left`,
        pageBreak: ``,
        fontSize: 15,
        color: ``,
      },
      {
        columns: [
          {
            preserveLeadingSpaces: true,
            color: ``,
            text: ``,
            decorationStyle: ``,
            width: 30,
            alignment: `left`,
            bold: false,
            pageBreak: ``,
            decoration: ``,
            decorationColor: ``,
            fontSize: 15,
          },
          {
            text: `ข้าพเจ้าได้อ่านหนังสือยินยอมฉบับนี้ หรือมีบุคคลอื่นให้ข้าพเจ้าเข้าใจแล้ว ข้าพเจ้ามีโอกาสซักถามและได้รับคำตอบเป็น`,
            alignment: `left`,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            bold: false,
            fontSize: 15,
            decoration: ``,
            width: `auto`,
            decorationStyle: ``,
            decorationColor: ``,
            color: ``,
          },
        ],
      },
      {
        text: `ที่หน้าพอใจ และมีเวลาเพียงพอในการพิจารณาเพื่อการตัดสินใจ`,
        pageBreak: ``,
        color: ``,
        decorationColor: ``,
        alignment: `left`,
        decoration: ``,
        bold: false,
        fontSize: 15,
        width: `auto`,
        decorationStyle: ``,
        preserveLeadingSpaces: true,
      },
      {
        bold: false,
        decoration: ``,
        width: `auto`,
        preserveLeadingSpaces: true,
        fontSize: 15,
        pageBreak: ``,
        color: ``,
        decorationStyle: ``,
        decorationColor: ``,
        alignment: `left`,
        text: `สำหรับผู้ป่วยผู้หญิง : ในกรณีที่ข้าพเจ้าตั้งครรภ์ ข้าพเจ้าเข้าใจว่าการผ่าตัดที่ไม่รีบด่วนนั้นควรจะทำหลังจากที่ ข้าพเจ้าคลอดบุตร`,
      },
      {
        pageBreak: ``,
        fontSize: 15,
        color: ``,
        text: `เรียบร้อยแล้ว ข้าพเจ้าเข้าใจว่ายาระงับความรู้สึกสามารถผ่านทางรกและอาจทำให้ทารกในครรภ์หมดความรู้สึกไปชั่วขณะ แม้ว่า`,
        preserveLeadingSpaces: true,
        decoration: ``,
        bold: false,
        decorationStyle: ``,
        width: `auto`,
        alignment: `left`,
        decorationColor: ``,
      },
      {
        fontSize: 15,
        pageBreak: ``,
        width: `auto`,
        alignment: `left`,
        bold: false,
        decoration: ``,
        decorationColor: ``,
        color: ``,
        text: `ภาวะแทรกซ้อนจากการใช้ยาระงับความรู้สึกระหว่างตั้งครรภ์จะเกิดขึ้นน้อยมากก็ตามแต่ความเสี่ยงที่จะเกิดต่อทารกในครรภ์นั้นหมายรวมถึง แต่มิได้จำกัดอยู่เพียง การพิการแต่กำเนิด การคลอดก่อนกำหนด สมองถูกทำลายอย่างถาวร และถึงขั้นเสียชีวิต`,
        decorationStyle: ``,
        preserveLeadingSpaces: true,
      },
      {
        columns: [
          {
            color: ``,
            decoration: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            pageBreak: ``,
            fontSize: 15,
            bold: false,
            width: 30,
            text: ``,
            alignment: `left`,
            decorationColor: ``,
          },
          {
            width: `auto`,
            decorationColor: ``,
            bold: false,
            pageBreak: ``,
            fontSize: 15,
            decorationStyle: ``,
            alignment: `left`,
            color: ``,
            preserveLeadingSpaces: true,
            decoration: ``,
            text: `ความเสี่ยงอื่นๆ ที่อาจเกิดขึ้นกับข้าพเจ้าจากการใช้ยาระงับความรู้สึก คือ: ..................................................................................`,
          },
        ],
      },
      {
        alignment: `left`,
        text: `…………………………………………………………………………………………………………….........................................................................................`,
        preserveLeadingSpaces: true,
        color: ``,
        width: `auto`,
        pageBreak: ``,
        decoration: ``,
        decorationStyle: ``,
        bold: false,
        fontSize: 15,
        decorationColor: ``,
      },
      {
        text: ``,
        pageBreak: `before`,
        decoration: ``,
        width: `auto`,
        fontSize: 15,
        decorationColor: ``,
        color: ``,
        bold: false,
        decorationStyle: ``,
        alignment: `left`,
        preserveLeadingSpaces: true,
      },
      {
        columns: [
          {
            pageBreak: ``,
            color: ``,
            width: `auto`,
            text: `ผู้ให้ข้อมูลข้างต้นแก่ข้าพเจ้าคือ `,
            bold: false,
            alignment: `left`,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            decoration: ``,
            fontSize: 15,
            decorationStyle: ``,
          },
          {
            decoration: ``,
            decorationColor: ``,
            text: ``,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            alignment: `left`,
            width: 5,
            fontSize: 15,
            bold: false,
            color: ``,
          },
          {
            stack: [
              {
                decorationColor: ``,
                preserveLeadingSpaces: true,
                bold: false,
                width: `auto`,
                pageBreak: ``,
                decoration: ``,
                color: ``,
                margin: [0, 0, 0, -15],
                decorationStyle: ``,
                alignment: `left`,
                text: props.items?.operatingData?.anes_name,
                fontSize: 15,
              },
              {
                decoration: ``,
                width: `auto`,
                margin: [0, 0, 0, 0],
                decorationColor: ``,
                bold: false,
                alignment: `left`,
                pageBreak: ``,
                decorationStyle: ``,
                fontSize: 15,
                text: `...............................................................................`,
                preserveLeadingSpaces: true,
                color: ``,
              },
            ],
          },
        ],
      },
      {
        decorationStyle: ``,
        fontSize: 15,
        text: `ณ ที่นี้ ข้าพเจ้าขอแสดงความยินยอมเพื่อรับการรักษาดังกล่าวข้างต้น`,
        decoration: ``,
        width: `auto`,
        bold: false,
        alignment: `left`,
        pageBreak: ``,
        preserveLeadingSpaces: true,
        decorationColor: ``,
        color: ``,
      },
      {
        alignment: `left`,
        decorationStyle: ``,
        text: ` `,
        fontSize: 15,
        decoration: ``,
        width: `auto`,
        decorationColor: ``,
        color: ``,
        preserveLeadingSpaces: true,
        bold: false,
        pageBreak: ``,
      },
      {
        columns: [
          {
            decorationStyle: ``,
            alignment: `center`,
            text: `ลงนาม........................................................   `,
            color: ``,
            decorationColor: ``,
            width: 200,
            pageBreak: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            decoration: ``,
            bold: false,
          },
          {
            decorationColor: ``,
            fontSize: 15,
            bold: false,
            text: `  `,
            width: 80,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            decorationStyle: ``,
            color: ``,
            decoration: ``,
            alignment: `left`,
          },
          {
            color: ``,
            alignment: `center`,
            fontSize: 15,
            pageBreak: ``,
            decoration: ``,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            decorationStyle: ``,
            width: 200,
            bold: false,
            text: `พยาน 1 ลงนาม........................................................ `,
          },
        ],
      },
      {
        columns: [
          {
            color: ``,
            alignment: `center`,
            fontSize: 15,
            bold: false,
            pageBreak: ``,
            decoration: ``,
            width: 200,
            text: `(.............................................................)`,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
          },
          {
            bold: false,
            decoration: ``,
            decorationStyle: ``,
            pageBreak: ``,
            color: ``,
            fontSize: 15,
            alignment: `left`,
            decorationColor: ``,
            width: 80,
            preserveLeadingSpaces: true,
            text: ``,
          },
          {
            text: `(.............................................................)`,
            decorationColor: ``,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            fontSize: 15,
            decorationStyle: ``,
            bold: false,
            color: ``,
            alignment: `center`,
            decoration: ``,
            width: 200,
          },
        ],
      },
      {
        columns: [
          {
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            text: `แพทย์ลงนาม........................................................`,
            bold: false,
            pageBreak: ``,
            width: 200,
            alignment: `center`,
            color: ``,
            decoration: ``,
            fontSize: 15,
          },
          {
            pageBreak: ``,
            decorationStyle: ``,
            text: ``,
            decoration: ``,
            alignment: `left`,
            fontSize: 15,
            width: 80,
            bold: false,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            color: ``,
          },
          {
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            text: `พยาน 2 ลงนาม........................................................`,
            alignment: `center`,
            width: 200,
            color: ``,
            bold: false,
            fontSize: 15,
            decoration: ``,
            pageBreak: ``,
            decorationColor: ``,
          },
        ],
      },
      {
        columns: [
          {
            bold: false,
            color: ``,
            fontSize: 15,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            alignment: `center`,
            decoration: ``,
            width: 200,
            decorationStyle: ``,
            text: `(.............................................................)`,
            pageBreak: ``,
          },
          {
            pageBreak: ``,
            preserveLeadingSpaces: true,
            color: ``,
            alignment: `left`,
            bold: false,
            decorationColor: ``,
            decorationStyle: ``,
            decoration: ``,
            text: ``,
            fontSize: 15,
            width: 80,
          },
          {
            alignment: `center`,
            decorationStyle: ``,
            decorationColor: ``,
            pageBreak: ``,
            width: 200,
            text: `(.............................................................)`,
            color: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            decoration: ``,
            bold: false,
          },
        ],
      },
      {
        columns: [
          {
            preserveLeadingSpaces: true,
            alignment: `center`,
            width: 200,
            text: `(แพทย์ผู้ให้คำอธิบาย)`,
            decorationStyle: ``,
            decoration: ``,
            color: ``,
            fontSize: 15,
            decorationColor: ``,
            pageBreak: ``,
            bold: false,
          },
          {
            alignment: `left`,
            text: ``,
            decoration: ``,
            pageBreak: ``,
            fontSize: 15,
            color: ``,
            width: 80,
            decorationStyle: ``,
            bold: false,
            preserveLeadingSpaces: true,
            decorationColor: ``,
          },
          {
            pageBreak: ``,
            bold: false,
            decorationColor: ``,
            alignment: `center`,
            fontSize: 15,
            decorationStyle: ``,
            color: ``,
            width: 200,
            decoration: ``,
            text: `(กรณีพิมพ์ลายนิ้วมือ/ยินยอมทางโทรศัพท์)`,
            preserveLeadingSpaces: true,
          },
        ],
      },
      {
        columns: [
          {
            alignment: `left`,
            decorationStyle: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            decorationColor: ``,
            color: ``,
            bold: false,
            text: ``,
            decoration: ``,
            width: 200,
          },
        ],
      },
      {
        columns: [
          {
            pageBreak: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            alignment: `center`,
            bold: false,
            decorationColor: ``,
            width: 200,
            color: ``,
            decorationStyle: ``,
            decoration: ``,
            text: `วันที่........................เวลา..................`,
          },
        ],
      },
      {
        decorationStyle: ``,
        decoration: ``,
        decorationColor: ``,
        width: `auto`,
        fontSize: 15,
        color: ``,
        preserveLeadingSpaces: true,
        pageBreak: ``,
        alignment: `left`,
        bold: false,
        text: ` `,
      },
      {
        columns: [
          {
            fontSize: 15,
            color: ``,
            decorationColor: ``,
            pageBreak: ``,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            decoration: `underline`,
            text: `การแปลและให้ข้อมูลโดยผู้แปลภาษา`,
            bold: `true`,
            width: `auto`,
            alignment: `left`,
          },
        ],
      },
      {
        columns: [
          {
            alignment: `left`,
            color: ``,
            width: `auto`,
            decorationStyle: ``,
            decorationColor: ``,
            fontSize: 15,
            decoration: ``,
            pageBreak: ``,
            bold: false,
            text: ``,
            preserveLeadingSpaces: true,
          },
          {
            pageBreak: ``,
            fontSize: 15,
            decorationColor: ``,
            bold: false,
            width: `auto`,
            decorationStyle: ``,
            text: `    ข้าพเจ้าได้แปลหนังสือยินยอมก่อนการให้ยาระงับปวดหรือยาระงับความรู้สึกตัวการทำหัตถการ/การผ่าตัด (Pre Procedural Sedation and Pre Anesthesia Informed Consent) รวมทั้งข้อมูลซึ่งแพทย์ได้อธิบายให้แก่ผู้ป่วย/ตัวแทนผู้ป่วยทราบ`,
            preserveLeadingSpaces: true,
            alignment: `left`,
            color: ``,
            decoration: ``,
          },
        ],
      },
      {
        columns: [
          {
            text: `ภาษาที่แปล................................................`,
            color: ``,
            alignment: `center`,
            width: 200,
            decorationStyle: ``,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            bold: false,
            fontSize: 15,
            decoration: ``,
            pageBreak: ``,
          },
          {
            text: ` `,
            color: ``,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            width: 80,
            decoration: ``,
            decorationColor: ``,
            fontSize: 15,
            decorationStyle: ``,
            bold: false,
            alignment: `left`,
          },
          {
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            text: `ผู้แปลลงนาม........................................................ `,
            width: 200,
            bold: false,
            fontSize: 15,
            pageBreak: ``,
            color: ``,
            decoration: ``,
            alignment: `center`,
            decorationColor: ``,
          },
        ],
      },
      {
        columns: [
          {
            pageBreak: ``,
            preserveLeadingSpaces: true,
            bold: false,
            decorationStyle: ``,
            decoration: ``,
            alignment: `left`,
            text: ``,
            color: ``,
            fontSize: 15,
            decorationColor: ``,
            width: 280,
          },
          {
            text: `(.............................................................)`,
            alignment: `center`,
            fontSize: 15,
            width: 200,
            decoration: ``,
            color: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            pageBreak: ``,
            decorationColor: ``,
            bold: false,
          },
        ],
      },
      {
        decoration: ``,
        text: ` `,
        decorationColor: ``,
        color: ``,
        preserveLeadingSpaces: true,
        pageBreak: `before`,
        decorationStyle: ``,
        width: `auto`,
        fontSize: 15,
        margin: [0, 0, 0, 0],
        bold: false,
        alignment: `left`,
      },
      AddTablePreSedationTH,
    ],
    header: props.header,
    footer: props.footer,
  };
}
